/**
 * Portal Manta · DiagnosticoPage
 * Extraído de App.jsx (v29 modular)
 */
import React, { useState, useEffect, useMemo, useCallback, Fragment, memo } from 'react';
import { DADOS } from '../../data/lotes-pr.js';
import { V, S, fmtNum, sumBy, fmtBRL, isAmpliacao, OBRAS_ROD } from '../../globals.js';
import { CONSOL_FIN } from '../../data/consol-fin.js';
import { THl, TH, TDl, TD } from '../../app-globals.js';

const DiagnosticoPage = memo(function DiagnosticoPage_Inner(){
  const lotes = ['3','4','5'];
  const checks = useMemo(()=>{
    const out = [];
    lotes.forEach(sig=>{
      const d = DADOS[sig]||{};
      const cf = CONSOL_FIN[sig]||{};
      const od = OBRAS_ROD[sig]||{};
      const dm = d.dados_manta||{};
      const cp = dm.compara_parametrico||{};
      const ext = parseFloat((d.extensao||'').replace(/[^\d,.]/g,'').replace(',','.'))||0;
      // Define checks
      const lote_checks = [
        {sec:'1 · Identificação', name:'Nome', ok:!!d.nome, val:d.nome},
        {sec:'1 · Identificação', name:'Sigla', ok:!!d.sig, val:d.sig},
        {sec:'1 · Identificação', name:'Extensão', ok:ext>0, val:d.extensao},
        {sec:'1 · Identificação', name:'Prazo', ok:!!d.prazo, val:d.prazo},
        {sec:'1 · Identificação', name:'Fase', ok:!!d.fase, val:d.fase},
        {sec:'1 · Identificação', name:'Órgão', ok:!!d.orgao, val:d.orgao},
        {sec:'2 · Financeiro', name:'TIR', ok:d.tir!=null, val:d.tir!=null?(d.tir*100).toFixed(2)+'%':'—'},
        {sec:'2 · Financeiro', name:'CAPEX total', ok:d.capex_total_b!=null, val:d.capex_total_b?'R$ '+fmtNum(d.capex_total_b,2)+' bi':'—'},
        {sec:'2 · Financeiro', name:'OPEX total', ok:d.opex_total_b!=null, val:d.opex_total_b?'R$ '+fmtNum(d.opex_total_b,2)+' bi':'—'},
        {sec:'2 · Financeiro', name:'Receita total', ok:!!d.receita_total, val:d.receita_total},
        {sec:'2 · Financeiro', name:'Tarifa teto', ok:!!d.tarifa_teto, val:d.tarifa_teto},
        {sec:'3 · Tipologias (PER)', name:'Lista de tipologias', ok:(d.tipologias||[]).length>0, val:(d.tipologias||[]).length+' itens'},
        {sec:'3 · Tipologias (PER)', name:'Tipologias de ampliação', ok:(d.tipologias||[]).filter(isAmpliacao).length>0, val:(d.tipologias||[]).filter(isAmpliacao).length+' itens'},
        {sec:'4 · OBRAS_ROD', name:'Sistema de rodovias', ok:(od.sistema||[]).length>0, val:(od.sistema||[]).length+' rodovias'},
        {sec:'4 · OBRAS_ROD', name:'Duplicações', ok:(od.duplicacoes||[]).length>0, val:fmtNum(sumBy(od.duplicacoes||[],'km'),1)+' km'},
        {sec:'4 · OBRAS_ROD', name:'OAEs', ok:(od.oaes||[]).length>0, val:sumBy(od.oaes||[],'n')+' un'},
        {sec:'4 · OBRAS_ROD', name:'Faixas adicionais', ok:(od.faixas||[]).length>0, val:fmtNum(sumBy(od.faixas||[],'km'),1)+' km'},
        {sec:'4 · OBRAS_ROD', name:'Marginais', ok:(od.marginais||[]).length>0, val:fmtNum(sumBy(od.marginais||[],'km'),1)+' km'},
        {sec:'4 · OBRAS_ROD', name:'Passarelas', ok:(od.passarelas||[]).length>0, val:sumBy(od.passarelas||[],'n')+' un'},
        {sec:'4 · OBRAS_ROD', name:'Interseções (D/T/P/R)', ok:((od.diamantes||[]).length+(od.trombetas||[]).length+(od.parclos||[]).length+(od.rotatorias||[]).length)>0, val:(sumBy(od.diamantes||[],'n')+sumBy(od.trombetas||[],'n')+sumBy(od.parclos||[],'n')+sumBy(od.rotatorias||[],'n'))+' un'},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Disciplinas', ok:Object.keys(cf).length>0, val:Object.keys(cf).length+' disciplinas'},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Itens SICRO', ok:Object.values(cf).reduce((s,a)=>s+a.length,0)>0, val:Object.values(cf).reduce((s,a)=>s+a.length,0)+' itens'},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Total R$', ok:Object.values(cf).reduce((s,a)=>s+sumBy(a,'v'),0)>0, val:fmtBRL(Object.values(cf).reduce((s,a)=>s+sumBy(a,'v'),0),0)},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Pavimentação', ok:(cf['PAVIMENTACAO']||[]).length>0, val:(cf['PAVIMENTACAO']||[]).length+' itens · '+fmtBRL(sumBy(cf['PAVIMENTACAO']||[],'v'),0)},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Terraplenos', ok:(cf['TERRAPLENOS E CONTENCOES']||[]).length>0, val:(cf['TERRAPLENOS E CONTENCOES']||[]).length+' itens · '+fmtBRL(sumBy(cf['TERRAPLENOS E CONTENCOES']||[],'v'),0)},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Drenagem', ok:(cf['DRENAGEM']||[]).length>0, val:(cf['DRENAGEM']||[]).length+' itens · '+fmtBRL(sumBy(cf['DRENAGEM']||[],'v'),0)},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'OAEs SICRO', ok:(cf['OAES']||[]).length>0, val:(cf['OAES']||[]).length+' itens · '+fmtBRL(sumBy(cf['OAES']||[],'v'),0)},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Sinalização', ok:(cf['SINALIZACAO']||[]).length>0, val:(cf['SINALIZACAO']||[]).length+' itens'},
        {sec:'5 · CONSOL_FIN (SICRO)', name:'Iluminação', ok:(cf['ILUMINACAO']||[]).length>0, val:(cf['ILUMINACAO']||[]).length+' itens · '+fmtBRL(sumBy(cf['ILUMINACAO']||[],'v'),0)},
        {sec:'6 · Dados Manta', name:'Compara Paramétrico', ok:(cp.itens||[]).length>0, val:(cp.itens||[]).length+' itens'},
        {sec:'6 · Dados Manta', name:'Capex Hier', ok:(dm.capex_hier||[]).length>0, val:(dm.capex_hier||[]).length+' grupos'},
        {sec:'6 · Dados Manta', name:'PR Vias preço', ok:(cp.itens||[]).some(it=>it.pr_vias?.preco_total>0), val:(cp.itens||[]).filter(it=>it.pr_vias?.preco_total>0).length+' c/ preço'},
        {sec:'6 · Dados Manta', name:'Engetec preço', ok:(cp.itens||[]).some(it=>it.engetec?.preco_total>0), val:(cp.itens||[]).filter(it=>it.engetec?.preco_total>0).length+' c/ preço'},
        {sec:'6 · Dados Manta', name:'Manta preço', ok:(cp.itens||[]).some(it=>it.df_plus?.preco_total>0), val:(cp.itens||[]).filter(it=>it.df_plus?.preco_total>0).length+' c/ preço'},
        {sec:'7 · Cronograma', name:'Cronograma', ok:(d.cronograma||[]).length>0, val:(d.cronograma||[]).length+' fases'},
      ];
      // Validações lógicas
      const totSicro = Object.values(cf).reduce((s,a)=>s+sumBy(a,'v'),0);
      const capex = (d.capex_total_b||0)*1e9;
      const ratio = capex?totSicro/capex:0;
      lote_checks.push(
        {sec:'⚑ Validações lógicas', name:'SICRO ÷ CAPEX', ok:ratio>0.05 && ratio<3,
         val:totSicro&&capex?`${(ratio*100).toFixed(1)}% (R$ ${fmtNum(totSicro/1e6,0)}mi / R$ ${fmtNum(capex/1e9,2)}bi)`:'—',
         alerta:ratio<0.05?'SICRO muito baixo':(ratio>3?'SICRO muito alto':null)},
        {sec:'⚑ Validações lógicas', name:'Σ extensão rodovias = ext lote', ok:Math.abs((od.sistema||[]).reduce((s,r)=>s+(r.ext||0),0)-ext)<5,
         val:`Σ rodovias=${fmtNum((od.sistema||[]).reduce((s,r)=>s+(r.ext||0),0),1)} km · lote=${fmtNum(ext,1)} km`},
      );
      out.push({sig, nome:d.nome||'?', checks:lote_checks});
    });
    return out;
  },[]);

  // Resumo agregado
  const total = checks.reduce((s,c)=>s+c.checks.length,0);
  const ok = checks.reduce((s,c)=>s+c.checks.filter(x=>x.ok).length,0);
  const pct = total?ok/total*100:0;
  const alertas = checks.flatMap(c=>c.checks.filter(x=>x.alerta));

  // Agrupa por seção
  const porSec = {};
  checks.forEach(lote=>{
    lote.checks.forEach(ch=>{
      if(!porSec[ch.sec]) porSec[ch.sec]={sec:ch.sec, byLote:{}};
      porSec[ch.sec].byLote[lote.sig] = porSec[ch.sec].byLote[lote.sig] || [];
      porSec[ch.sec].byLote[lote.sig].push(ch);
    });
  });

  return(<div style={S.page}>
    <div style={S.h1}>⚑ Diagnóstico do Portal · agente validador</div>
    <div style={S.sub}>
      Varredura automática dos dados embutidos · 3 lotes × {Object.values(porSec).length} seções · 
      <b style={{color:V.br,marginLeft:6}}>{ok}/{total}</b> verificações OK ({pct.toFixed(1)}%)
    </div>
    {/* Resumo header */}
    <div style={{display:'grid',gridTemplateColumns:'repeat(3,1fr)',gap:10,marginBottom:14}}>
      <div style={{...S.cardP,borderLeft:'4px solid '+V.gn}}>
        <div style={{fontSize:9.5,fontWeight:700,color:V.gn,letterSpacing:.3}}>OK</div>
        <div style={{fontSize:18,fontWeight:700,color:V.br,marginTop:3}}>{ok}</div>
        <div style={{fontSize:10,color:V.gr}}>de {total} verificações</div>
      </div>
      <div style={{...S.cardP,borderLeft:'4px solid '+V.or}}>
        <div style={{fontSize:9.5,fontWeight:700,color:V.or,letterSpacing:.3}}>FALTANDO</div>
        <div style={{fontSize:18,fontWeight:700,color:V.br,marginTop:3}}>{total-ok}</div>
        <div style={{fontSize:10,color:V.gr}}>campos sem dado</div>
      </div>
      <div style={{...S.cardP,borderLeft:'4px solid '+(V.am||'#d97706')}}>
        <div style={{fontSize:9.5,fontWeight:700,color:V.am||'#d97706',letterSpacing:.3}}>ALERTAS</div>
        <div style={{fontSize:18,fontWeight:700,color:V.br,marginTop:3}}>{alertas.length}</div>
        <div style={{fontSize:10,color:V.gr}}>validações lógicas</div>
      </div>
    </div>
    {/* Detalhamento por seção × lote */}
    <div style={{...S.card,overflow:'hidden'}}>
      <table style={{width:'100%',borderCollapse:'collapse',fontSize:10.5}}>
        <thead style={S.thRow}><tr style={{borderBottom:'2px solid '+V.b1}}>
          <th style={THl}>Seção / Verificação</th>
          {lotes.map(l=>(<th key={l} style={TH}>L{l}</th>))}
        </tr></thead>
        <tbody>
          {Object.values(porSec).map(grupo=>{
            // pegar o nome de cada check (consistente entre lotes)
            const checksList = grupo.byLote[lotes[0]]||[];
            return(<Fragment key={grupo.sec}>
              <tr><td colSpan={4} style={{padding:'8px 10px',fontSize:10,fontWeight:700,letterSpacing:.5,color:V.gr,background:V.g0}}>{grupo.sec}</td></tr>
              {checksList.map((c,i)=>{
                return(<tr key={i} style={S.trLine}>
                  <td style={{...TDl,paddingLeft:20}}>{c.name}</td>
                  {lotes.map(l=>{
                    const cl = (grupo.byLote[l]||[])[i];
                    const ok = cl?.ok;
                    const cor = ok?V.gn:(cl?.alerta?V.am||'#d97706':V.or);
                    const sym = ok?'✓':(cl?.alerta?'⚠':'✕');
                    return(<td key={l} style={{...TD,color:cor}} title={cl?.val||''}>
                      <span style={{fontWeight:700}}>{sym}</span>
                      <span style={{fontSize:9.5,marginLeft:4,color:V.gr,fontWeight:500}}>{cl?.val?(cl.val.length>20?cl.val.slice(0,18)+'…':cl.val):'—'}</span>
                    </td>);
                  })}
                </tr>);
              })}
            </Fragment>);
          })}
        </tbody>
      </table>
    </div>
    {/* Alertas detalhados */}
    {alertas.length>0 && <div style={{...S.cardP,marginTop:10,borderLeft:'4px solid '+(V.am||'#d97706')}}>
      <div style={{fontSize:11,fontWeight:700,color:V.br,marginBottom:6}}>Alertas detalhados</div>
      {alertas.map((a,i)=>(<div key={i} style={{fontSize:10.5,color:V.gr,padding:'2px 0'}}>
        ⚠ <b>{a.name}</b>: {a.alerta} ({a.val})
      </div>))}
    </div>}
  </div>);
});

export { DiagnosticoPage };
export default DiagnosticoPage;
